module.exports = __webpack_public_path__ + "media/flags/bj-8d6fbc83.svg";